module.exports = __webpack_public_path__ + "static/media/User-circle.4de40549.svg";